import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Lock({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        d="M10 8.99998V6.33331C10 5.22874 10.8955 4.33331 12 4.33331C13.1046 4.33331 14 5.22874 14 6.33331V8.99998H10ZM15.3334 6.33331V8.99998H18.666C19.4025 8.99998 20 9.59694 20 10.334V19.666C20 20.4033 19.4022 21 18.666 21H5.334C4.59754 21 4 20.403 4 19.666V10.334C4 9.59669 4.59779 8.99998 5.334 8.99998H8.66671V6.33331C8.66671 4.49236 10.1591 2.99998 12 2.99998C13.841 2.99998 15.3334 4.49236 15.3334 6.33331ZM14 10.3333H15.3334L18.666 10.3333C18.6664 10.3333 18.6667 10.3336 18.6667 10.334V19.666C18.6667 19.6663 18.6664 19.6666 18.666 19.6666H5.334C5.33363 19.6666 5.33333 19.6663 5.33333 19.666V10.334C5.33333 10.3336 5.33363 10.3333 5.334 10.3333L8.66671 10.3333H10H14ZM12 13C11.2636 13 10.6667 13.5969 10.6667 14.3333V15.6666C10.6667 16.403 11.2636 17 12 17C12.7364 17 13.3333 16.403 13.3333 15.6666V14.3333C13.3333 13.5969 12.7364 13 12 13Z"
        fill={iconColor}
      />
    </Svg>
  );
}
